<template>
  <div class="vip-render-price">
    <div class="vip-render-price-name">{{ name }}</div>
    <ym-price class="vip-render-price-primary"
              type="gold"
              :price="price"
    />
    <ym-price v-if="showDeletePrice"
              class="vip-render-price-delete"
              type="gold"
              :price="delPrice"
              del
    />
  </div>
</template>

<script>
  import Price from '@/components/Price';

  export default {
    name: 'ProductDetailBottomVipRenderPriceBtn',
    components: {
      'ym-price': Price,
    },
    props: {
      name: {
        type: String,
      },
      price: {
        type: [Number, String],
        required: true,
      },
      delPrice: {
        type: [Number, String],
      },
    },
    computed: {
      showDeletePrice() {
        return this.delPrice > this.price;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-render-price {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex: 1;
    line-height: 1;

    &-name {
      color: @color-text-gold;
      margin-right: @size-extra-small + 2;
      word-break: keep-all;
    }

    &-primary {
      line-height: .8;
      margin-right: @size-extra-small/2;
      /deep/ .price-unit {
        line-height: .9;
      }
    }
  }
</style>
